/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Run_Approval_Preselected_DeclineInputs */



/**
* | output |
* | --- |
* | "You chose Reject in the email. Click Reject to confirm it." |
*
* @param {Agent_Run_Approval_Preselected_DeclineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_run_approval_preselected_decline = /** @type {((inputs?: Agent_Run_Approval_Preselected_DeclineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Run_Approval_Preselected_DeclineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben in der E-Mail „Ablehnen“ gewählt. Klicken Sie zur Bestätigung auf „Ablehnen“.")
	return /** @type {LocalizedString} */ ("You chose Reject in the email. Click Reject to confirm it.")
});